import { render } from "./VCola.vue?vue&type=template&id=c7606760"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/VCola.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c7606760"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c7606760', __exports__)) {
    api.reload('c7606760', __exports__)
  }
  
  module.hot.accept("./VCola.vue?vue&type=template&id=c7606760", () => {
    api.rerender('c7606760', render)
  })

}


export default __exports__